import { useMemo } from 'react';
import { BsDot } from 'react-icons/bs';
import { RiStarLine } from 'react-icons/ri';

import { Repository } from '@models/Repository';

import { Container, Text, Info } from './styles';

interface Props {
  repository: Repository;
}

const RepositoryItem: React.FC<Props> = ({ repository }) => {
  const lastUpdate = useMemo(
    () => new Date(repository?.updated_at).toLocaleDateString(),
    [repository?.updated_at]
  );
  const repositoryUrl = useMemo(
    () => repository?.clone_url?.replace('.git', ''),
    [repository?.clone_url]
  );

  return (
    <Container data-cy="repository-item">
      <a href={repositoryUrl} target="_blank" rel="noreferrer">
        <Text>
          <span className="name">{repository?.name}</span>

          {repository?.description ? (
            <p className="description">{repository?.description}</p>
          ) : (
            <p className="empty-description">No description</p>
          )}
        </Text>

        <Info>
          <span className="stars">
            <RiStarLine /> {repository?.stargazers_count}
          </span>
          <span className="last-update">
            <BsDot /> Last update at {lastUpdate}
          </span>
        </Info>
      </a>
    </Container>
  );
};

export default RepositoryItem;
